
import React from 'react';

const CompletionTransition: React.FC = () => {
  return (
    <div className="fixed inset-0 bg-gradient-to-t from-emerald-50 to-background z-20 animate-fade-in opacity-0" />
  );
};

export default CompletionTransition;
